// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalFilter_root__pZx0s","footer":"ModalFilter_footer__3ZEjk"};